import { Action, combineReducers, Reducer } from 'redux';

import account from './account-reducer';
import auth from './auth-reducer';
import { home } from './home-reducer';
import { initialAvailableRolesState } from './initState/initAvailableRolesState';
import { notification } from './notification-reducer';
import { organisations } from './organisations-reducer';
import settings, {
  deviceConfigurationSetting,
  securitySettings,
  sftpSettings,
  twoFactorAuthenticationSetting,
} from './organisationSettings-reducer';
import { patients } from './patients/patients-reducer';
import preregisteredDevicesUpload from './preregisteredDevices-reducer';
import reports from './report-reducer';
import sdCardUpload from './sdCardUpload-reducer';
import sleepMonitoring from './sleep-monitoring';
import tenant from './tenant-reducer';
import trustedBrowsers from './trustedBrowsers-reducer';
import { users } from './users-reducer';
import { CLEAR_STORE } from '@shared/redux/actions';
import { ActionWithPayload } from '@shared/redux/actions/typings';
import { RootState } from '@shared/redux/state/root';

export const availableRoles = (state = initialAvailableRolesState(), action: ActionWithPayload<any>) => {
  return {
    ...state,
  };
};

export const allReducers = () => ({
  auth,
  settings,
  securitySettings,
  sftpSettings,
  twoFactorAuthenticationSetting,
  deviceConfigurationSetting,
  trustedBrowsers,
  patients,
  users,
  home,
  tenant,
  account,
  organisations,
  sleepMonitoring,
  notification,
  reports,
  sdCardUpload,
  preregisteredDevicesUpload,
  availableRoles,
});

const app = () => combineReducers(allReducers());

const appReducer = (): Reducer<RootState, Action<any>> => (prevState, action) => {
  let state: Partial<RootState> | undefined = prevState;
  if (action.type === CLEAR_STORE && prevState) {
    state = {
      tenant: prevState.tenant,
      home: prevState.home,
    };
    state.auth = prevState.auth;
  }

  return app()(state as RootState, action);
};

export default appReducer;
